export const FETCH_COMMENTS_INITIATED = 'FETCH_COMMENTS_INITIATED'
export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS'
export const ADD_COMMENT_INITIATED = 'ADD_COMMENT_INITIATED'
export const ADD_COMMENT_SUCCESSFUL = 'ADD_COMMENT_SUCCESSFUL'
export const FETCH_COMMENTS_FAIL = 'FETCH_COMMENTS_FAIL'
export const EDIT_COMMENT_SUCCESSFULL = 'EDIT_COMMENT_SUCCESSFULL'
export const SAVE_ANNOTATION_MODE = 'SAVE_ANNOTATION_MODE'
export const SELECTED_COMMENT_ID = 'SELECTED_COMMENT_ID'
export const HIGHLIGHT_COMMENT_ID = 'HIGHLIGHT_COMMENT_ID'
